import * as React from 'react';
import { useNavigate } from 'react-router-dom';
// Show both the top-items carousel and the full items list below.
import Items from './items/items';
import LeadForm from './leadForm';
import ActionImageCard from './actionImageCard';
import '../style/items.css';
import '../style/actionImageCard.css';
import '../style/utils.css';
import '../style/header.css';
import '../style/base.css';
import '../style/homeTabs.css';
import ApiClient, { getImageUrl } from '../Services/ApiClient';
import { useResources, useComponentResources } from '../store/resourcesProvider';
import { postVisit } from '../Services/trafficApi';

const Home = () => {

    const [showLeadForm, setShowLeadForm] = React.useState(false);
    const [goToItemId, setGoToItemId] = React.useState<number | null>(null);
    const navigate = useNavigate();

    const openLeadForm = (itemId: number) => {
        setShowLeadForm(true);
        setGoToItemId(itemId);

    }

    // use Items component for infinite scroll and responsive grid/list

    const closeModalAndGoToItemPage = (itemId: number) => {
        setShowLeadForm(false);
        navigate('/item/' + itemId);
    }

    const resources = useResources();
    const pageResources = useComponentResources('Home', [
        'Home.Promo1',
        'Home.Promo2',
        'Home.Promo3',
        'Home.Signer',
        'Header.Name',
        'Header.Subtitle',
        'Header.Subtitle2',
        // tabs and vocal teaching resources
        'Home.Tab.Therapy',
        'Home.Tab.Vocal',
        'Home.Vocal.Title',
        'Home.Vocal.Subtitle',
        'Home.Vocal.VisionTitle',
        'Home.Vocal.VisionText',
        'Home.Vocal.TraditionTitle',
        'Home.Vocal.TraditionText',
        'Home.Vocal.PrinciplesTitle',
        'Home.Vocal.Principle1',
        'Home.Vocal.Principle2',
        'Home.Vocal.Principle3',
        'Home.Vocal.WhatLearnTitle',
        'Home.Vocal.WhatLearn1',
        'Home.Vocal.WhatLearn2',
        'Home.Vocal.WhatLearn3',
        'Home.Vocal.CareerTitle',
        'Home.Vocal.CareerText',
        'Home.Vocal.Invitation'
    ]);

    const getInitialTab = (): 'therapy'|'vocal' => {
        try {
            // read from hash (#vocal or #therapy) or query string (?tab=vocal)
            const hash = (window.location.hash || '').replace('#', '').toLowerCase();
            if (hash === 'vocal' || hash === 'therapy') return hash as 'vocal'|'therapy';
            const params = new URLSearchParams(window.location.search);
            const t = (params.get('tab') || '').toLowerCase();
            if (t === 'vocal' || t === 'therapy') return t as 'vocal'|'therapy';
        } catch { }
        return 'therapy';
    };

    const [activeTab, setActiveTab] = React.useState<'therapy'|'vocal'>(getInitialTab);

    // persist tab to URL hash and respond to back/forward via hashchange
    React.useEffect(() => {
        try {
            if (window && window.location) {
                const newHash = activeTab;
                if (window.location.hash.replace('#','') !== newHash) {
                    // update hash without scrolling
                    history.replaceState(null, '', window.location.pathname + window.location.search + '#' + newHash);
                }
            }
        } catch { }
    }, [activeTab]);

    React.useEffect(() => {
        const onHash = () => {
            try {
                const h = (window.location.hash || '').replace('#','').toLowerCase();
                if (h === 'vocal' || h === 'therapy') setActiveTab(h as 'vocal'|'therapy');
            } catch { }
        };
        window.addEventListener('hashchange', onHash);
        return () => window.removeEventListener('hashchange', onHash);
    }, []);

    // Report a visit when the home page is entered
    React.useEffect(() => {
        try {
            postVisit('home');
        } catch { }
    }, []);

    return (
        <>
            <div id="divHeaderText">

                <div>
                    <div className="header-container" style={{ marginRight: 8 }}>
                        <div className="header-main">{pageResources['Header.Name'] ?? resources.get('Header.Name', 'אפרת בורוכובסקי')}</div>
                        <div className="header-sub">{pageResources['Header.Subtitle'] ?? resources.get('Header.Subtitle', 'טיפול בקול')}</div>
                        <div className="header-sub2">{pageResources['Header.Subtitle2'] ?? resources.get('Header.Subtitle2', 'טיפול בקול (Voice Therapy) מסייע לשפר את איכות הקול, לחזק את השליטה בו ולהפחית מאמץ או כאב בזמן דיבור. באמצעות תרגילים מותאמים אישית ניתן ללמוד להשתמש בקול בצורה נכונה ויעילה יותר, לשפר נשימה והפקת קול, ולהתגבר על צרידות, עייפות קולית או בעיות קול אחרות. בנוסף, העבודה עם הקול יכולה לתרום גם לרווחה נפשית: היא מאפשרת ביטוי רגשי, חיזוק הביטחון העצמי, הפחתת מתח וחרדה, ופיתוח מודעות טובה יותר לגוף ולנשימה. כך, הטיפול תורם הן לבריאות הקול והן לאיזון רגשי ולתחושת רווחה כללית.')}</div>
                    </div>
                </div>
            </div>
            {/* Top promotional area - moved items list into main content below to avoid duplicates */}
            <div id="divMainText" className="divMainText">
                <div className="home-tabs">
                    <div className="tab-buttons" role="tablist">
                        <button className={`tab-button ${activeTab === 'therapy' ? 'active' : ''}`} role="tab" aria-selected={activeTab === 'therapy'} onClick={() => setActiveTab('therapy')}> {pageResources['Home.Tab.Therapy'] ?? resources.get('Home.Tab.Therapy','טיפול בקול')} </button>
                        <button className={`tab-button ${activeTab === 'vocal' ? 'active' : ''}`} role="tab" aria-selected={activeTab === 'vocal'} onClick={() => setActiveTab('vocal')}> {pageResources['Home.Tab.Vocal'] ?? resources.get('Home.Tab.Vocal','שיעורי פיתוח קול')} </button>
                    </div>

                    <div className={`tab-content ${activeTab === 'therapy' ? 'visible' : 'hidden'}`} aria-hidden={activeTab !== 'therapy'}>
                        {activeTab === 'therapy' && (
                            <>
                                <div>
                                    {pageResources['Home.Promo1'] ?? resources.get('Home.Promo1', 'שנים של לימוד אצל מיטב המסגרות והמורים, בראו דרך המיוחדת לי בהוראת פיתוח הקול.')}
                                </div>
                                <div>
                                    {pageResources['Home.Promo2'] ?? resources.get('Home.Promo2', 'אשמח לחלוק איתך את הכלים שרכשתי וללוות אותך בתהליך עד לרווחה הנפשית שלך.')}
                                </div>
                                <div>
                                    {pageResources['Home.Promo3'] ?? resources.get('Home.Promo3', 'המפגשים מועברים בסטודיו מלא בכלי נגינה וציוד תנועה המאפשר לקול הפנימי שלך לצאת לאויר העולם...')}
                                </div>
                                <div>
                                    {pageResources['Home.Signer'] ?? resources.get('Home.Signer', 'נתראה במפגש\nאפרת בורוכובסקי')}
                                </div>
                            </>
                        )}
                    </div>

                    <div className={`tab-content ${activeTab === 'vocal' ? 'visible' : 'hidden'}`} aria-hidden={activeTab !== 'vocal'}>
                        {activeTab === 'vocal' && (
                            <div className="vocal-section" dir="rtl">
                                <h2 className="vocal-title">{pageResources['Home.Vocal.Title'] ?? resources.get('Home.Vocal.Title', 'אפרת בורוכובסקי – קול, ביטוי ומסורת של מצוינות')}</h2>
                                <h3 className="vocal-sub">{pageResources['Home.Vocal.Subtitle'] ?? resources.get('Home.Vocal.Subtitle', 'זמרת סולנית ומורה בכירה לפיתוח קול')}</h3>

                                <h4 className="section-title">{pageResources['Home.Vocal.VisionTitle'] ?? resources.get('Home.Vocal.VisionTitle','החזון האמנותי: איפה שהטכניקה פוגשת את הנשמה')}</h4>
                                <p className="section-paragraph">{pageResources['Home.Vocal.VisionText'] ?? resources.get('Home.Vocal.VisionText','אפרת בורוכובסקי מאמינה שכל קול הוא טביעת אצבע ייחודית. בסטודיו שלה, העבודה על פיתוח הקול היא תהליך של גילוי – הסרת המחסומים שמונעים מהקול להישמע במלוא הדרו, ובניית תשתית טכנית איתנה המאפשרת חופש אמנותי מוחלט.')}</p>

                                <h4 className="section-title">{pageResources['Home.Vocal.TraditionTitle'] ?? resources.get('Home.Vocal.TraditionTitle','הקשר למסורת של חנה הכהן')}</h4>
                                <p className="section-paragraph">{pageResources['Home.Vocal.TraditionText'] ?? resources.get('Home.Vocal.TraditionText','בבסיס הידע המקצועי של אפרת עומדת השנים של עבודה צמודה והשתלמות אצל חנה הכהן ז\'ל, מהמורות החשובות והמשפיעות ביותר בהיסטוריה של המוזיקה בישראל.')}</p>

                                <h4 className="section-title">{pageResources['Home.Vocal.PrinciplesTitle'] ?? resources.get('Home.Vocal.PrinciplesTitle','כממשיכת דרכה של הכהן, אפרת מיישמת בשיעוריה את עקרונות הגישה הייחודית:')}</h4>
                                <ul className="principles-list">
                                    <li>{pageResources['Home.Vocal.Principle1'] ?? resources.get('Home.Vocal.Principle1','הקול כחלק מהגוף כולו: עבודה על שחרור פיזי, יציבה ונשימה אורגנית.')}</li>
                                    <li>{pageResources['Home.Vocal.Principle2'] ?? resources.get('Home.Vocal.Principle2','דיוק פונטי ומוזיקלי: הקפדה על הגייה נכונה ועל ניואנסים מוזיקליים דקים.')}</li>
                                    <li>{pageResources['Home.Vocal.Principle3'] ?? resources.get('Home.Vocal.Principle3','חיבור רגשי עמוק: ההבנה שטכניקה היא אמצעי ולא מטרה.')}</li>
                                </ul>

                                <h4 className="section-title">{pageResources['Home.Vocal.WhatLearnTitle'] ?? resources.get('Home.Vocal.WhatLearnTitle','מה לומדים בסטודיו?')}</h4>
                                <ul className="what-learn-list">
                                    <li>{pageResources['Home.Vocal.WhatLearn1'] ?? resources.get('Home.Vocal.WhatLearn1','ביסוס יסודות: עבודה על תמיכה, מנעד, מעברים וגמישות קולית.')}</li>
                                    <li>{pageResources['Home.Vocal.WhatLearn2'] ?? resources.get('Home.Vocal.WhatLearn2','רפרטואר מגוון: שירה קלאסית, מחזות זמר, פופ ומוזיקה ישראלית עכשווית.')}</li>
                                    <li>{pageResources['Home.Vocal.WhatLearn3'] ?? resources.get('Home.Vocal.WhatLearn3','הכנה למקצוענים: ליווי לאודишנים, הקלטות אולפן ובניית מופעים.')}</li>
                                </ul>

                                <h4 className="section-title">{pageResources['Home.Vocal.CareerTitle'] ?? resources.get('Home.Vocal.CareerTitle','עלי ועל הקריירה')}</h4>
                                <p className="section-paragraph">{pageResources['Home.Vocal.CareerText'] ?? resources.get('Home.Vocal.CareerText','אפרת היא בוגרת האקדמיה למוזיקה ולמחול בירושלים, בעלת ניסיון עשיר כזמרת סולנית ובהוראה מקצועית שמעמיקה את ההבנה לאתגרים בשלב הביצוע.')}</p>

                                <p className="invitation">{pageResources['Home.Vocal.Invitation'] ?? resources.get('Home.Vocal.Invitation','"אני מזמינה אותך למסע של גילוי קולי, במקום שבו הדיוק המקצועי שקיבלתי ממורתי הגדולה, חנה הכהן, פוגש את הקול הייחודי שלך."')}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="home-layout page-padding">
                <main className="home-content">
                    <div className="items-section">
                        <Items />
                    </div>
                </main>
                <aside className="home-sidebar">
                    <div className="divForm sticky">
                        <LeadForm showDiscountImage={true} />
                    </div>
                </aside>
            </div>

            {showLeadForm && (
                <div className="modal-overlay" onClick={() => closeModalAndGoToItemPage(goToItemId)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => closeModalAndGoToItemPage(goToItemId)}>×</button>
                        <LeadForm
                            showDiscountImage={false}
                            onSubmit={() => closeModalAndGoToItemPage(goToItemId)} // <-- close modal after submit
                        />
                    </div>
                </div>
            )}

        </>
    )
}

export default Home;